"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UNAVAILABLE = "UNAVAILABLE";
exports.ERROR = "ERROR";
exports.YES = "YES";
exports.NO = "NO";
